import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from '../../shared/guard/authentication-guard';
import { ModuleRedirectGuard } from '../../shared/guard/module-redirect-guard';
import { VersionDetailsComponent } from './version/version-details/version-details.component';

const routes: Routes = [
  {
    path: 'Configuration',
    pathMatch: 'full',
    canActivate: [AuthenticationGuard, ModuleRedirectGuard],
    data: { moduleRedirect: 'configuration' },
    children: [],
  },
  {
    path: 'Configuration/Version',
    component: VersionDetailsComponent,
    canActivate: [AuthenticationGuard],
    data: {
      breadcrumb: { label: 'Version' },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConfigurationRoutingModule {}
